import { render } from "./ReservationCompleted.vue?vue&type=template&id=1ae4a728"
import script from "./ReservationCompleted.vue?vue&type=script&lang=js"
export * from "./ReservationCompleted.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\anygence\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__